export default "__VITE_ASSET__Brq8xgDe__"